import { TabModules } from '~/data/company';
import { EmployeeModuleConfig } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/types';

export enum EmployeeModuleTabPath_People {
  Basic = 'basic',
  CustomData = 'custom-data',
  DecisionRegistry = 'decision-registry',
  JobDescription = 'job-description',
  Contact = 'contact',
  Equipment = 'equipment',
  Documents = 'documents',
  Absences = 'absences',
  Performance = 'performance',
  Development = 'development',
  Collaboration = 'collaboration',
}

export enum EmployeeModuleTabConfigKey_People {
  Absences = 'PEOP_ABSENCES',
  Basic = 'PEOP_BASIC',
  Contact = 'PEOP_CONTACT',
  CustomData = 'PEOP_CUSTOM_DATA',
  DecisionRegistry = 'PEOP_DECISION_REGISTRY',
  Development = 'PEOP_DEVELOPMENT',
  Documents = 'PEOP_DOCUMENTS',
  Equipment = 'PEOP_EQUIPMENT',
  JobDescription = 'PEOP_JOB_DESCRIPTION',
  Performance = 'PEOP_PERFORMANCE',
  Collaboration = 'PEOP_COLLABORATION',
}

export enum EmployeeModuleTabInstructionKey_People {
  Absences = 'INSTRUCTIONS_EMP_TIME_OFF',
  Basic = 'INSTRUCTIONS_EMP_BASIC_DATA',
  CustomData = 'INSTRUCTIONS_EMP_CUSTOM_DATA',
  Contact = 'INSTRUCTIONS_EMP_CONTACT',
  DecisionRegistry = 'INSTRUCTIONS_EMP_DECISION_REGISTRY',
  Development = 'INSTRUCTIONS_EMP_DEVELOPMENT',
  Documents = 'INSTRUCTIONS_EMP_DOCUMENT',
  Equipment = 'INSTRUCTIONS_EMP_COMPANY_EQUIPMENT',
  JobDescription = 'INSTRUCTIONS_EMP_POSITION_CUSTOM_DATA',
  Performance = 'INSTRUCTIONS_EMP_PERFORMANCE',
  Collaboration = 'INSTRUCTIONS_EMP_COLLABORATION',
}

export const EmployeeModuleRouting_People: EmployeeModuleConfig<
  EmployeeModuleTabPath_People,
  EmployeeModuleTabConfigKey_People,
  EmployeeModuleTabInstructionKey_People
> = {
  path: 'people',
  module: TabModules.PEOPLE,
  defaultTab: EmployeeModuleTabPath_People.Basic,
  tabConfigs: [
    {
      path: EmployeeModuleTabPath_People.Basic,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.Basic,
      instructionKey: EmployeeModuleTabInstructionKey_People.Basic,
    },
    {
      path: EmployeeModuleTabPath_People.CustomData,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.CustomData,
      instructionKey: EmployeeModuleTabInstructionKey_People.CustomData,
    },
    {
      path: EmployeeModuleTabPath_People.DecisionRegistry,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.DecisionRegistry,
      instructionKey: EmployeeModuleTabInstructionKey_People.DecisionRegistry,
    },
    {
      path: EmployeeModuleTabPath_People.JobDescription,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.JobDescription,
      instructionKey: EmployeeModuleTabInstructionKey_People.JobDescription,
    },
    {
      path: EmployeeModuleTabPath_People.Contact,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.Contact,
      instructionKey: EmployeeModuleTabInstructionKey_People.Contact,
    },
    {
      path: EmployeeModuleTabPath_People.Equipment,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.Equipment,
      instructionKey: EmployeeModuleTabInstructionKey_People.Equipment,
    },
    {
      path: EmployeeModuleTabPath_People.Documents,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.Documents,
      instructionKey: EmployeeModuleTabInstructionKey_People.Documents,
    },
    {
      path: EmployeeModuleTabPath_People.Absences,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.Absences,
      instructionKey: EmployeeModuleTabInstructionKey_People.Absences,
    },
    {
      path: EmployeeModuleTabPath_People.Performance,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.Performance,
      instructionKey: EmployeeModuleTabInstructionKey_People.Performance,
    },
    {
      path: EmployeeModuleTabPath_People.Development,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.Development,
      instructionKey: EmployeeModuleTabInstructionKey_People.Development,
    },
    {
      path: EmployeeModuleTabPath_People.Collaboration,
      enabledConfigKey: EmployeeModuleTabConfigKey_People.Collaboration,
      instructionKey: EmployeeModuleTabInstructionKey_People.Collaboration,
    },
  ],
};
